module.exports = __webpack_public_path__ + "static/media/void.8641c08c.svg";